import React from 'react';
import PersonPhoto from '../FileCard/PersonPhoto';
import { Button, message, Upload } from 'antd';
import axios from 'axios';
import { getPersonAvatarRoute, getPersonPhotoRoute } from '../../lib/routes/persons';
import { RcFile } from 'antd/es/upload';
import { useAppSelector } from '../../store/hooks';
import ImgCrop from 'antd-img-crop';
import usePermissions from '../../lib/utils/usePermissions';
import { PERSON_WRITE, PERSON_WRITE_ALLREGIONS } from '../../lib/const/permissions';
import { ReactComponent as PencilLineIcon } from '../../lib/img/pencil_line.svg';
import { ReactComponent as ClearIcon } from '../../lib/img/icon/profile/clear.svg';
import './ProfileImage.less';

const beforeUpload = (file: RcFile) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('Данный формат не поддерживается. Пожалуйста загрузите файл png, jpeg, jpg');
  }
  const isLt2M = file.size / 1024 / 1024 < 5;
  if (!isLt2M) {
    message.error('Размер изображения не должен превышать 5Мб.');
  }
  return isJpgOrPng && isLt2M;
};

const beforeCrop = (file: File, _: File[]) => {
  const isLt2M = file.size / 1024 / 1024 < 5;
  if (!isLt2M) {
    message.error('Размер изображения не должен превышать 5Мб.');
    return false;
  }
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('Данный формат не поддерживается. Пожалуйста загрузите файл png, jpeg, jpg');
    return false;
  }
  return isLt2M;
};

interface Props {
  myProfile: boolean;
  image?: any;
  handleNewImage: (file, route) => void;
  isImageLoading?: boolean;
  heightPhoto?: number;
  widthPhoto?: number;
  loadAvatar?: () => void;
}

function ProfileImageNew(props: Props) {
  const { image, myProfile, handleNewImage, isImageLoading, heightPhoto, widthPhoto, loadAvatar } = props;
  const { meUserFull, personFullCard } = useAppSelector((state) => state.persons);
  const [hasAccess] = usePermissions();

  const route = () => (myProfile ? getPersonAvatarRoute(meUserFull?.id) : getPersonPhotoRoute(personFullCard?.id));

  const handleDelete = () => {
    axios.delete(route()).then(() => {
      message.success('Изображение удалено');
      loadAvatar && loadAvatar();
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <PersonPhoto
        myProfile={myProfile}
        image={image}
        isLoading={isImageLoading}
        heightPhoto={heightPhoto}
        widthPhoto={widthPhoto}
      >
        {hasAccess([PERSON_WRITE, PERSON_WRITE_ALLREGIONS]) || myProfile ? (
          <div
            onClick={handleDelete}
            className="clear-icon-profile"
            style={{
              display: !image ? 'none' : 'block',
            }}
          >
            <ClearIcon />
          </div>
        ) : null}
      </PersonPhoto>

      {(hasAccess([PERSON_WRITE, PERSON_WRITE_ALLREGIONS]) || myProfile) && (
        <ImgCrop rotate modalTitle="Редактирование аватара" beforeCrop={beforeCrop}>
          <Upload
            name="avatar"
            beforeUpload={beforeUpload}
            showUploadList={false}
            customRequest={({ file }) => {
              handleNewImage(file, route);
            }}
          >
            <div className="mt10 display-flex change-icon-profile" style={{ alignItems: 'center', cursor: 'pointer' }}>
              <PencilLineIcon className="mr4" />
              <span style={{ textAlign: 'center' }}>Изменить изображение</span>
            </div>
          </Upload>
        </ImgCrop>
      )}
    </div>
  );
}

export default ProfileImageNew;
